import { connect } from 'formik';
import type { FormikProps } from 'formik';

import { Box } from '@hivebrite/design-system/Box';

import { Radio } from 'hb-react/shared/components/formik/components/inputs';

interface SimpleProps {
  formik: FormikProps<any>;
}

const Simple = ({ formik }: SimpleProps) => {
  const handleRecurringChange = (value) => {
    if (value === 'true') {
      formik.setFieldValue('donation_order[recurring_payment_enabled]', 'true');
      formik.setFieldValue('donation_order[periodicity]', 'month');
    } else {
      formik.setFieldValue(
        'donation_order[recurring_payment_enabled]',
        'false',
      );
      formik.setFieldValue('donation_order[periodicity]', 'three_months');
    }
  };

  return (
    <Box m="auto" mb={30} width="100%">
      <Radio
        name="donation_order[monthly_payment]"
        type="toggle"
        validate={{
          required: true,
        }}
        inputs={[
          {
            value: 'false',
            label: s__('Donations|Give once'),
          },
          {
            value: 'true',
            label: s__('Donations|Give monthly'),
          },
        ]}
        onChange={handleRecurringChange}
      />
    </Box>
  );
};

export default connect(Simple);
